import PhaseSix from "components/Participant/CompleteSelfServey/SurveyPhase/PhaseSix"
import React from "react"

const PhaseSixPage = () => {
    return (
        <React.Fragment>
            <PhaseSix />
        </React.Fragment>
        
    )
}
export default PhaseSixPage
